import React, { useEffect, useCallback, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import Connect from "../../../shared/redux/Connect.hoc";
import Modal from 'react-bootstrap4-modal'
import LoaderSpinner from "../../../shared/components/LoaderSpinner/LoaderSpinner";

function DetalleMensajeria({ state, visibleDetalle, onCloseDetalle }) {

  useEffect(() => {
    console.log("--DetalleMensajeria.Component.useEffect-- ");
    console.log("--DetalleMensajeria.Component.useEffect-- detalle: ", state.mensajeria.mensajeria);

  }, []);

  const closeModal = () => {
    console.log("--DetalleMensajeria.Component.useEffect-- ");
    onCloseDetalle()
  }
  return (
    <Modal visible={visibleDetalle} onClickBackdrop={closeModal}>
      <div className="modal-header text-center">
        <h1 className="modal-title w-100" style={{ fontFamily: " Montserrat" }} >Detalle Servicio</h1>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeModal} >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <div>
          <div style={{ fontFamily: " Montserrat" }}>
            Dirección Origen:
            <div style={{ fontFamily: " Montserrat", color: "#858585" }}>
              {state.mensajeria.origen.direccion}
            </div>
          </div>
          <br />
          <div style={{ fontFamily: " Montserrat" }}>
            Dirección Destino:
            <div style={{ fontFamily: " Montserrat", color: "#858585" }}>
              {state.mensajeria.destino.direccion}
            </div>
          </div>
          <br />
          <div style={{ fontFamily: " Montserrat" }}>
            Fecha Creación:
            <div style={{ fontFamily: " Montserrat", color: "#858585" }}>
              {state.mensajeria.fecha_creacion_view}
            </div>
          </div>
          <br />
          <div style={{ fontFamily: " Montserrat" }}>
            Valor Total:
            <div style={{ fontFamily: " Montserrat", color: "#858585" }}>
              ${state.mensajeria.valor_total}
            </div>
          </div>
          <br />
          <div style={{ fontFamily: " Montserrat" }}>
            Distancia:
            <div style={{ fontFamily: " Montserrat", color: "#858585" }}>
              {state.mensajeria.distancia}Km
              </div>
          </div>
          <br />
          <div style={{ fontFamily: " Montserrat" }}>
            Tipo Pquete:
            <div style={{ fontFamily: " Montserrat", color: "#858585" }}>
              {state.mensajeria.paquete}
            </div>
          </div>
          <br />
          <div style={{ fontFamily: " Montserrat" }}>
            Estado:
            <div style={{ fontFamily: " Montserrat", color: "#858585" }}>
              {state.mensajeria.estado}
            </div>
            <br />
            <div style={{ fontFamily: " Montserrat" }}>
              Fecha Solicitud:
                <div style={{ fontFamily: " Montserrat", color: "#858585" }}>
                {state.mensajeria.fecha_creacion_view}
              </div>
            </div>
            <br />
            {state.mensajeria.estado == 'Asignado' && (
              <div style={{ fontFamily: " Montserrat" }}>
                Fecha Asignado:
                <div style={{ fontFamily: " Montserrat", color: "#858585" }}>
                  {state.mensajeria.fecha_modificacion_view}
                </div>
              </div>
            )}
            {state.mensajeria.estado == 'Aceptado' && (
              <div>
                <div style={{ fontFamily: " Montserrat" }}>
                  Fecha Aceptado:
                <div style={{ fontFamily: " Montserrat", color: "#858585" }}>
                    {state.mensajeria.fecha_aceptado_view}
                  </div>
                </div>
                <br />
                <div style={{ fontFamily: " Montserrat" }}>
                  Técnico Responsable:
                <div style={{ fontFamily: " Montserrat", color: "#858585" }}>
                    {state.mensajeria.tecnico.name} {state.mensajeria.tecnico.lastname}
                  </div>
                </div>
              </div>
            )}
            {state.mensajeria.estado == 'Terminado' && (
              <div>
                <div style={{ fontFamily: " Montserrat" }}>
                  Fecha Terminado:
                <div style={{ fontFamily: " Montserrat", color: "#858585" }}>
                    {state.mensajeria.fecha_terminado_view}
                  </div>
                </div>
                <br />
                <div style={{ fontFamily: " Montserrat" }}>
                  Mensajero Responsable:
                <div style={{ fontFamily: " Montserrat", color: "#858585" }}>
                    {state.mensajeria.tecnico.name} {state.mensajeria.tecnico.lastname}
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </Modal>
  )
}
export default withRouter(Connect(DetalleMensajeria))